import { Component, Input } from '@angular/core';
import { HeaderLogoComponent } from '../header-logo/header-logo.component';
import { Section } from '../../../dto/response/template.config';
import { Router } from '@angular/router';
import { MenuComponent } from '../../widgets/menu/menu.component';
import { MenuService } from '../../../service/menu.service';
import { CartComponent } from '../../cart/cart.component';
import { LanguageComponent } from '../language/language.component';

@Component({
  selector: 'app-second-bar',
  standalone: true,
  imports: [HeaderLogoComponent, MenuComponent, CartComponent, LanguageComponent],
  templateUrl: './second-bar.component.html',
  styleUrl: './second-bar.component.scss',
})
export class SecondBarComponent {
  @Input() section!: Section | undefined;

  constructor(
    private router: Router,
    private menuService: MenuService,
  ) {}

  mainMenuOpen() {
    this.menuService.mainMenuToggle = true;
  }
}
